import apiClient, { unwrap } from './client';

export const flocksApi = {
  getAll: async () => {
    const res = await apiClient.get('/flocks');
    return unwrap(res) ?? [];
  },

  getByRoom: async (roomId) => {
    const res = await apiClient.get(`/flocks/room/${roomId}`);
    return unwrap(res) ?? [];
  },

  create: async (flock) => {
    const res = await apiClient.post('/flocks', flock);
    return unwrap(res);
  },

  update: async (id, flock) => {
    const res = await apiClient.put(`/flocks/${id}`, flock);
    return unwrap(res);
  },

  remove: async (id) => {
    await apiClient.delete(`/flocks/${id}`);
  },
};
